import { Spinner } from "reactstrap";
import FormField from "../ui/FormField";
import { Button } from "../Button";
import { X } from "lucide-react";

const GSTInfoClient = ({ formData, setFormData,showCreateGst,isGstId, setShowCreateGst, errors,isLoading, handelUpdate }) => {
    console.log("isGstId====>",isGstId)
    const onChange = (name, value) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <div onClick={(e)=> e.stopPropagation()} className="bg-white w-4/5 md:w-3/5 p-2 rounded-lg z-50 max-h-[90vh] overflow-auto">
            <div className="flex flex-row items-center justify-between border-b border-b-gray-200 pb-2">
                <div className="text-lg font-semibold text-gray-900">GST Registration {isGstId ? "Edit" : "New"}</div>
                <button
                    type="button"
                    onClick={() => {
                        setShowCreateGst(false);
                        setFormData({
                        id: null,
                        registrationNumber: '',
                        gstin: '',
                        registrationType: 'Regular',
                        activeStatus: true
                                    });}} 
                    className="bg-red-50 p-1rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
                >
                    <X/>
                </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-start">
                {/* <FormField
                    label="Registration Number"
                    value={formData.registrationNumber}
                    onChange={v => onChange('registrationNumber', v)}
                    error={errors?.registrationNumber}
                    required
                /> */}

                <FormField
                    label="GSTIN"
                    value={formData.gstin}
                    onChange={v => onChange('gstin', v)}
                    error={errors?.gstin}
                    required
                />

                <FormField
                    label="Registration Type"
                    type="dropdown"
                    value={formData.registrationType}
                    options={['Regular', 'Composition', 'SEZ', 'Other']}
                    onChange={v => onChange('registrationType', v)}
                    error={errors?.registrationType}
                    required
                />
            </div>
           
            <div className='flex flex-row items-center justify-end gap-2'>
                <button
                    type="button"
                    onClick={() => {
                        setShowCreateGst(false);
                        setFormData({
                        id: null,
                        registrationNumber: '',
                        gstin: '',
                        registrationType: 'Regular',
                        activeStatus: true
                                    });}}  
                    className="bg-red-50 py-2 px-4 border border-red-300 rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
                >
                    Cancel
                </button>
                {isLoading ? 
                <Button label={<Spinner size={"sm"}/>}/> :
                <Button label={isGstId ? "Update" : "Save"} type="button" onClick={(e)=> handelUpdate(e)} className="m-2"/>
                }
            </div>
        </div>
    );
};

export default GSTInfoClient;